<template>
    <v-container>
        {{ cartItemprice }}
    </v-container>
</template>

<script>
export default {
    name: 'CartItemPrice',
    props:{
      cartItemPrice:{
        type: String,
        required: true
      }
    },
}
</script>


// WEBPACK FOOTER //
// src/components/Cart/CartItemPrice.vue